/*
 * 功能名称: 	部门工作拆分粒度指标
 * 创 建 人: lichunyang
 * 日    期: 2025年7月25日11:35:30
 */
import { NewviewOaBaseApi } from './NewviewOaBaseApi'

export class WorkKpiDictionaryApi extends NewviewOaBaseApi {
  public get ControllerName(): any {
    return 'work-kpi-dictionary'
  }
}
